const routes = [
  {
    path: '/product-case',
    name: 'product-case',
    component: () => import('@/views/product-case/index.vue'),
    redirect: '/product-case/list',
    meta: {
      title: '零件管理',
      noBg: true,
      icon: 'el-icon-box'
    },
    children: [
      {
        path: 'list',
        name: 'product-case-list',
        component: () => import('@/views/product-case/list.vue'),
        meta: {
          title: '零件列表',
          noBg: true
        }
      },
      {
        path: 'edit',
        name: 'product-case-edit',
        component: () => import('@/views/product-case/edit.vue'),
        meta: {
          title: '上传零件图片',
          noBg: true,
          unMenu: true,
          activeMenu: 'product-case-list'
        }
      }
    ]
  }
];

export default routes;
